import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContactInfoPwa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={6} />
    <path
      stroke='#fff'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M24.478 21.748c0 .27-.06.547-.188.817-.127.27-.293.525-.51.765a3.4 3.4 0 0 1-1.23.885q-.674.284-1.463.285c-.764 0-1.582-.18-2.445-.547a13.2 13.2 0 0 1-2.58-1.485 21.6 21.6 0 0 1-2.46-2.1 21 21 0 0 1-2.092-2.453c-.615-.855-1.11-1.71-1.47-2.557q-.54-1.283-.54-2.453c0-.51.09-.997.27-1.447q.268-.689.863-1.253c.48-.473 1.005-.705 1.56-.705.21 0 .42.045.607.135.195.09.367.225.502.42l1.74 2.453c.136.187.233.36.3.525.068.157.105.315.105.457q0 .272-.157.533c-.097.172-.24.352-.42.532l-.57.593a.4.4 0 0 0-.12.3c0 .06.008.112.023.172.022.06.045.105.06.15.135.247.367.57.697.96q.504.586 1.087 1.185c.406.398.796.765 1.193 1.102.39.33.713.556.968.69.037.015.082.038.135.06.06.023.12.03.187.03a.41.41 0 0 0 .307-.127l.57-.562q.282-.283.54-.42a1 1 0 0 1 .533-.158q.212-.002.457.098a3 3 0 0 1 .525.292l2.483 1.762c.195.136.33.293.413.48.075.188.12.376.12.585Z'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M21.875 14.75c0-.45-.352-1.14-.878-1.703-.48-.517-1.117-.922-1.747-.922M24.5 14.75a5.246 5.246 0 0 0-5.25-5.25'
    />
  </svg>
);
export default SvgContactInfoPwa;
